import React from 'react'
import { config } from '../../../../config';
import PaymentStatus from '../PaymentStatus/PaymentStatus';
import './PaymentIdCard.scss';

const { statuses, errorMessages } = config;

export const PaymentIdCard = ({status, paymentId = "", confirmedAmount}) => {
    return (
        <div className={`payment-id-card-component ${status}`}>
              <div className="payment-id-card-component__container">
                  <PaymentStatus status={status} />

                  <p className="payment-id-card-component__container--text">
                    {status === statuses.confirmed ? 
                        <span>The payment of {confirmedAmount && <b>{confirmedAmount} {config.currencies.ADA.symbol}</b>} was confirmed.</span> : 
                        errorMessages[status]
                    }
                  </p>

                  {paymentId && <p className="payment-id-card-component__container--payment-id">Your payment id is: <b>{paymentId}</b></p> }
              </div>
        </div>
    )
}

export default PaymentIdCard;